import AlertIcon from "assets/images/defaultIcons/alerts.svg";
import ContactIcon from "assets/images/defaultIcons/contact.svg";
import DataIcon from "assets/images/defaultIcons/data.svg";
import FileMultiIcon from "assets/images/defaultIcons/file-multi.svg";
import LocationIcon from "assets/images/defaultIcons/location.svg";
import ManagerIcon from "assets/images/defaultIcons/manager.svg";
import Report from "assets/images/defaultIcons/report.svg";
import TeamIcon from "assets/images/defaultIcons/team.svg";
export * from "shared/constants";

// Routes

// Auth
export const SCREEN_ADMIN_LOGIN = "admin-login";
export const SCREEN_ADMIN_REGISTER = "admin-register";
export const SCREEN_ADMIN_FORGOT = "admin-forgot-password";
export const SCREEN_CREATE_ORGANIZATION = "admin-create-organization";
export const SCREEN_RESET_PASSWORD = "reset";
export const SCREEN_PRIVACY = "privacy";
export const SCREEN_CONTACT = "contact";

export const AUTH_SCREEN_NAMES = {
  [SCREEN_ADMIN_LOGIN]: "Admin Login",
  [SCREEN_ADMIN_REGISTER]: "Admin Register",
  [SCREEN_ADMIN_FORGOT]: "Admin Forgot Password",
  [SCREEN_RESET_PASSWORD]: "Password Reset",
  [SCREEN_CREATE_ORGANIZATION]: "Create Organization",
  [SCREEN_PRIVACY]: "Privacy Policy",
  [SCREEN_CONTACT]: "Contact Us",
};

// Dashboard
export const SCREEN_DASHBOARD_PEOPLE = "people";
export const SCREEN_DASHBOARD_MANAGE_PERSON = "manage-person";
export const SCREEN_DASHBOARD_OTHER_CONTACTS = "other-contacts";
export const SCREEN_DASHBOARD_PLACES = "places";
export const SCREEN_DASHBOARD_ALERTS = "alerts";
export const SCREEN_DASHBOARD_PLATFORMS = "platforms";
export const SCREEN_DASHBOARD_BCP_INFO = "bcp-info";
export const SCREEN_DASHBOARD_TEAMS = "teams";
export const SCREEN_DASHBOARD_ORGANIZATION_SETTINGS = "organization-settings";
export const SCREEN_DASHBOARD_HOME = "home";
export const SCREEN_ACCOUNT_SETTINGS = "account-settings";

export const DASHBOARD_SCREENS = {
  [SCREEN_DASHBOARD_ALERTS]: {
    icon: AlertIcon,
    title: "Alerts",
  },
  [SCREEN_DASHBOARD_PLATFORMS]: {
    icon: DataIcon,
    title: "Platforms",
  },
  [SCREEN_DASHBOARD_BCP_INFO]: {
    icon: FileMultiIcon,
    title: "BCP Info",
  },
  [SCREEN_DASHBOARD_TEAMS]: {
    icon: TeamIcon,
    title: "Teams",
  },
  [SCREEN_DASHBOARD_PEOPLE]: {
    icon: ContactIcon,
    title: "People",
  },
  [SCREEN_DASHBOARD_MANAGE_PERSON]: {
    title: "Manage Person",
  },
  [SCREEN_DASHBOARD_OTHER_CONTACTS]: {
    icon: ContactIcon,
    title: "Other Contacts",
  },
  [SCREEN_DASHBOARD_ORGANIZATION_SETTINGS]: {
    icon: ManagerIcon,
    title: "Organization Settings",
  },
  [SCREEN_DASHBOARD_PLACES]: {
    icon: LocationIcon,
    title: "Places",
  },
  [SCREEN_DASHBOARD_HOME]: {
    icon: Report,
    title: "Home",
  },
  [SCREEN_ACCOUNT_SETTINGS]: {
    title: "Account Settings",
  },
};

export const ALERT_ACCESSOR_SYSTEM = "system";
export const ALERT_ACCESSOR_LOCATION = "location";
export const ALERT_ACCESSOR_TEAM = "team";

export const ALERT_ACCESSOR_LIST = [
  ALERT_ACCESSOR_SYSTEM,
  ALERT_ACCESSOR_LOCATION,
  ALERT_ACCESSOR_TEAM,
];
